import { useMutation, queryCache } from 'react-query';
import axios from 'axios';
import useStore from 'zstore';
import { ApiUser, CreateApiUserPayload } from '../types';

interface CreateApiUserParams {
  partnerId: number;
  payload: CreateApiUserPayload;
}

const createApiUser = async ({ partnerId, payload }: CreateApiUserParams): Promise<ApiUser> => {
  const response = await axios.post(`/api/v4/partners/${partnerId}/api_users`, payload);
  return response.data;
};

export const useCreateApiUser = () => {
  const { makeToast } = useStore();

  return useMutation(createApiUser, {
    onSuccess: () => {
      makeToast({ text: 'API key created successfully.', isError: false });
    },
    onError: (error: any) => {
      console.error('Error creating API user:', error);
      const errorMessage = error.response?.data?.message || 'Error creating API key. Please try again.';
      makeToast({ text: errorMessage, isError: true });
    },
    onSettled: (data, error, variables) => {
      queryCache.invalidateQueries(['apiUsers', variables.partnerId]);
    },
  });
};